import { render, staticRenderFns } from "./MatterLegalEvidenceSamplesForm.vue?vue&type=template&id=d61a221c&"
import script from "./MatterLegalEvidenceSamplesForm.vue?vue&type=script&lang=js&"
export * from "./MatterLegalEvidenceSamplesForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterLegalEvidenceSamplesForm.vue?vue&type=style&index=0&id=d61a221c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports